import React, { Component } from "react";
import { Element, scroller } from "react-scroll";
import MessageItem from "./MessageItem";
import MessageInput from "../AdminSupport/LiveChat/MessageInput";
import Firebase from "../../firebasehelper";
import { getStringfromSeconds } from "../../functions";

const calendar_png = require("../../assets/media/calendar-hub/calendar.png");
const ring_png = require("../../assets/media/chatsuite/ring.png");
const video_png = require("../../assets/media/chatsuite/video.png");
const voice_png = require("../../assets/media/chatsuite/voice.png");
var a = require("indefinite");
var timer;

class MessageList extends Component {
  state = {
    showInput: false,
    messages: [],
    name: "",
    isIphoneX: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      messages: [],
      user_typing: false,
      landlord_typing: false,
      contractor_typing: false,
    };
  }

  componentDidMount() {
    let { room_id, ticket, username, brand } = this.props;
    const {
      time,
      ticket_id,
      title,
      adjective,
      item,
      room,
      band,
      repair_sla,
      response_sla,
      issue,
    } = ticket;
    let time_str = getStringfromSeconds(time);
    Firebase.getChats(room_id, ticket_id, (res) => {
      let chats = Object.values(res);
      if (title === "Home Repairs") {
        chats.unshift(
          {
            message: `The <b>${item}</b> in the <b>${room}</b> is <b>${adjective}</b>.`,
            type: "user",
          },
          {
            message: `This is ${a(band)}.`,
            type: "bot",
          },
          {
            message: `This is covered by Ecosystem.`,
            type: "bot",
          },
          {
            message: `${
              brand && a(brand, { capitalize: true })
            } worker will be in touch ${response_sla}.`,
            type: "bot",
          },
          {
            message: `${brand} aim to have this repair made ${repair_sla}.`,
            type: "bot",
          }
        );
      } else if (title === "Support") {
        chats.unshift({
          message: issue,
          type: "user",
        });
      }
      if (title !== "EcoChat")
        chats.unshift({
          message: `${username} has requested help with <b>${title}</b> on ${time_str}.`,
          type: "user",
          username: "Bot",
        });
      else
        chats.unshift({
          message: `${brand} has requested EcoChat to ${username} on ${time_str}.`,
          type: "bot",
          username: "Bot",
        });
      this.setState({ messages: chats });
    });
    Firebase.getUserTyping(room_id, ticket_id, (typing) => {
      this.setState({ user_typing: typing });
    });
    Firebase.getLandlordTyping(room_id, ticket_id, (typing) => {
      this.setState({ landlord_typing: typing });
    });
    Firebase.getContractorTyping(room_id, ticket_id, (typing) => {
      this.setState({ contractor_typing: typing });
    });
    this.scrollToBottom();
  }
  componentWillReceiveProps(nextProps) {
    let { room_id, ticket, username, brand } = nextProps;
    const {
      time,
      ticket_id,
      title,
      adjective,
      item,
      room,
      band,
      repair_sla,
      response_sla,
      issue,
    } = ticket;
    let time_str = getStringfromSeconds(time);
    Firebase.getChats(room_id, ticket_id, (res) => {
      let chats = Object.values(res);
      if (title === "Home Repairs") {
        chats.unshift(
          {
            message: `The <b>${item}</b> in the <b>${room}</b> is <b>${adjective}</b>.`,
            type: "user",
          },
          {
            message: `This is ${a(band)}.`,
            type: "bot",
          },
          {
            message: `This is covered by Ecosystem.`,
            type: "bot",
          },
          {
            message: `${a(brand, {
              capitalize: true,
            })} worker will be in touch ${response_sla}.`,
            type: "bot",
          },
          {
            message: `${brand}  aim to have this repair made ${repair_sla}.`,
            type: "bot",
          }
        );
      } else if (title === "Support") {
        chats.unshift({
          message: issue,
          type: "user",
        });
      }
      if (title !== "EcoChat")
        chats.unshift({
          message: `${username} has requested help with <b>${title}</b> on ${time_str}.`,
          type: "user",
          username: "Bot",
        });
      else
        chats.unshift({
          message: `${brand} has requested EcoChat to ${username} on ${time_str}.`,
          type: "bot",
          username: "Bot",
        });
      this.setState({ messages: chats });
    });
    Firebase.getUserTyping(room_id, ticket_id, (typing) => {
      this.setState({ user_typing: typing });
    });
    Firebase.getLandlordTyping(room_id, ticket_id, (typing) => {
      this.setState({ landlord_typing: typing });
    });
    Firebase.getContractorTyping(room_id, ticket_id, (typing) => {
      this.setState({ contractor_typing: typing });
    });
  }
  scrollToBottom(delay = 0) {
    scroller.scrollTo("bottom", {
      duration: 200,
      delay: 0,
      smooth: "easeInOutQuart",
      containerId: "containerElement",
    });
  }

  setMessages() {
    const { logo, icon, userIcon, territory, username } = this.props;
    const { messages } = this.state;
    setTimeout(() => this.scrollToBottom(), 100);
    return messages.map((message, i) => {
      return (
        <MessageItem
          message={message}
          key={i}
          logo={logo}
          icon={icon}
          territory={territory}
          userIcon={userIcon}
          loaded={true}
          username={username}
        />
      );
    });
  }

  setMessageInState(message) {
    const messages = this.state.messages.slice();
    messages.push(message);
    this.setState({ messages });
  }

  addMessage = (message) => {
    const { room_id, ticket } = this.props;
    const { ticket_id } = ticket;

    this.setMessageInState(message);
    message.time = Date.now();
    Firebase.addMessage(room_id, ticket_id, message, (res) => {
      if (ticket.status === "Waiting") {
        Firebase.acceptRequest(room_id, ticket_id);
      }
      Firebase.setUnReadMessage(room_id, ticket_id, {
        latest: message.message,
        time: message.time,
        ticket: ticket,
      });
    });
    Firebase.setTypeValue(room_id, ticket_id, false);
    setTimeout(() => this.scrollToBottom(), 100);
  };
  onType = () => {
    const { room_id, ticket } = this.props;
    const { ticket_id } = ticket;
    Firebase.setTypeValue(room_id, ticket_id, true);
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      Firebase.setTypeValue(room_id, ticket_id, false);
    }, 1000);
  };
  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }
  render() {
    const { userIcon, comingtask, username } = this.props;
    const { user_typing, landlord_typing, contractor_typing } = this.state;
    return (
      <div className="message-list-wrapper-container">
        <div className="message-list-wrapper">
          {comingtask && (
            <div className="top-bar">
              <img src={calendar_png} width="40" />
              <p>
                Appointment {this.formatAMPM(comingtask.performAt.toDate())} -{" "}
                {comingtask.options.duration}min
              </p>
              <div
                className="d-flex flex-row align-items-center justify-content-between"
                style={{ width: 100 }}
              >
                <img src={ring_png} width="30" alt="ring" />
                <img src={video_png} width="30" alt="video" />
                <img src={voice_png} width="30" alt="voice" />
              </div>
            </div>
          )}
          <Element className="message-items-container" id="containerElement">
            {this.setMessages()}
            {user_typing && (
              <MessageItem
                message={{ type: "user" }}
                loaded={false}
                userIcon={userIcon}
              />
            )}
            {landlord_typing && (
              <MessageItem message={{ type: "landlord" }} loaded={false} />
            )}
            {contractor_typing && (
              <MessageItem message={{ type: "contractor" }} loaded={false} />
            )}
            <Element name="bottom"></Element>
          </Element>
          <div
            component="div"
            className="message-input-container"
            ref={(el) => {
              this.messagesEnd = el;
            }}
          >
            <MessageInput
              addMessage={this.addMessage}
              onType={this.onType}
              username={username}
              type="bot"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default MessageList;



// WEBPACK FOOTER //
// ./src/screens/LiveChat/MessageList.js